let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6533T")).then(() => parcelRequire('2AmUl'));